import React from "react";
import { Routes, Route } from "react-router-dom";
import { Container } from "@mui/material";
import { VenueList } from "./VenueList";
import { VenueForm } from "./VenueForm";
import { VenueDetails } from "./VenueDetails";

export const VenuesPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Routes>
        <Route path="/" element={<VenueList />} />
        <Route path="/new" element={<VenueForm />} />
        <Route path="/:id" element={<VenueDetails />} />
        <Route path="/:id/edit" element={<VenueForm />} />
      </Routes>
    </Container>
  );
};
